import axios from 'axios'

const server_path = 'http://' + process.env.HOST + ':8000/api/'

export function getData(url){
  return axios
      .get(server_path + url)
      .then(res => res)
      .catch(error => error)
}
export function getOutsideData(url){
  return axios
      .get(url)
      .then(res => res)
      .catch(error => error)
}


export function setData(url,data){
  return axios
      .post(server_path + url, data)
      .then(res => res)
      .catch(error => {
        if (error.response) {
          return error.response
        } else {
          return error
        }
      })
}

export function putData(url,id,data){
  return axios
      .put(server_path + url + id + "/", data)
      .then(res => res)
      .catch(error => error)
}

export function deleteData(url,id){
  return axios
      .delete(server_path + url + id + "/")
      .then(res => res)
      .catch(error => error)
}

export function  upload(form,file) {
  const url = server_path + 'upload/'
  const formData = new FormData()
  for (const key in form) {formData.append(key,form[key])}
  formData.append('file',file)
  return axios
    .post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      },
    })
    .then(res=> res)
    .catch(error => { this.$noty.error("Oops, something went wrong!")});
}
